import { Avatar, Button, Col } from "antd";
import { DeleteOutlined } from "@ant-design/icons";

import Table from "../../../shared/components/ui/Table";
import { useCampaignsProducts, useTableCampaignsProducts } from "../hooks";
import { ISingleProductForCampaign } from "../hooks/useCampaignsProducts";
import { TableColumns } from "../../../shared/components/ui/Table/types";
import { campaignProductsService } from "../../../shared/services";
import { PATH_S3_BUCKET } from "../../../shared/utils/constants";

export const TableCampaignsProducts = () => {
  const { showDeleteConfirm } = useTableCampaignsProducts();
  const { setTableProps, id } = useCampaignsProducts();

  const columns: TableColumns<ISingleProductForCampaign> = [
    {
      title: "ID",
      width: 3,
      dataIndex: "id",
      key: "id",
      filterType: "text",
    },
    {
      title: "Imagen",
      width: 4,
      dataIndex: ["product", "main_image"],
      key: "main_image",
      render: (_, item) => {
        const path = item.product?.main_image;
        if (!path) return null;
        return (
          <Avatar shape="square" size={56} src={`${PATH_S3_BUCKET}/${path}`} />
        );
      },
    },
    {
      title: "Producto",
      width: 12,
      dataIndex: ["product", "name"],
      key: "name",
    },
    {
      title: "Acciones",
      key: "operation",
      fixed: "right",
      width: 3,
      render: (_, item) => {
        return (
          <Col
            style={{
              display: "flex",
              width: "100%",
              justifyContent: "space-evenly",
              flexDirection: "row",
            }}
          >
            <Button
              type="primary"
              danger
              onClick={() =>
                showDeleteConfirm(item.id, `${item.product?.name ?? item.id}`)
              }
              shape="circle"
              icon={<DeleteOutlined />}
              size="large"
            />
          </Col>
        );
      },
    },
  ];

  return (
    <Table<ISingleProductForCampaign>
      columns={columns}
      fetchQueryProps={{
        campaign_id: id,
        $sort: { id: -1 },
      }}
      service={campaignProductsService}
      onLoad={setTableProps}
    />
  );
};
